import { appURLs } from "@/app/constants.mjs";
import { devWarn } from "@/util/dev.mjs";

/**
 * Instead if using a large yaml-parsing library, we will
 * just manually parse the version out of the first line of
 * the file. There is some risk that this is fragile if the
 * source changes, but we control the source and that is unlikely.
 */
export function parseWindowsVersion(yamlString) {
  const firstLine = yamlString.split("\n", 1)?.[0];

  const match = "version: ";

  if (firstLine.includes(match)) {
    return firstLine.substring(match.length);
  }

  devWarn(
    "Failed to parse version from yaml string. Confirm the yaml data is valid",
    { yamlString },
  );
}

export async function getLatestWindowsRelease() {
  // eslint-disable-next-line blitz/prefer-get-data
  const response = await fetch(appURLs.BLITZ_STABLE_WINDOWS);

  if (!response.ok) {
    return;
  }

  const data = await response.text();

  const version = parseWindowsVersion(data);

  return version;
}

/**
 * Instead if using a large rss-parsing library, we will
 * just manually parse the version out of the file. There is
 * some risk that this is fragile if the source changes, but
 * we control the source and that is unlikely.
 */
export function parseMacVersion(yamlString) {
  return parseWindowsVersion(yamlString);
}

export async function getLatestMacRelease() {
  // eslint-disable-next-line blitz/prefer-get-data
  const response = await fetch(appURLs.BLITZ_STABLE_MAC);

  if (!response.ok) {
    return;
  }

  const data = await response.text();

  const result = parseMacVersion(data);

  return result;
}
